import { useState, useEffect } from "react";
import { AiLoader } from "frontend/canvas-designer-new/ai-generator/ai-loader/ai-loader";
import styles from "./dependency-mapping-loader.module.css";

const loaderSteps = [
  "Fetching items from your board",
  "Analyzing dependency relationships",
  "Mapping connections between tasks",
  "Building the dependency structure",
  "Identifying critical path items",
  "Organizing tasks by dependencies",
  "Creating visual connections",
  "Arranging elements for clarity",
  "Optimizing the layout",
  "Adding finishing touches",
];

const STEP_INTERVAL_MS = 3_000;

export function DependencyMappingLoader() {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStepIndex((currentIndex) => (currentIndex + 1) % loaderSteps.length);
    }, STEP_INTERVAL_MS);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.loaderContainer}>
      <AiLoader />
      <p className={styles.loaderStepText} key={stepIndex}>
        {loaderSteps[stepIndex]}
      </p>
    </div>
  );
}
